import ManagementGroup from '@/services/api/groupManagementCompany';

export default {
  namespaced: true,
  state: {
    managementsGroup: [],
    managementGroup: {},
  },
  getters: {
    managementsGroup: state => state.managementsGroup,
    managementGroup: state => state.managementGroup,
  },
  mutations: {
    setManagementsGroup: (state, payload) => {
      state.managementsGroup = payload;
    },
    setManagementGroup: (state, payload) => {
      state.managementGroup = payload;
    },
  },
  actions: {
    getManagementsGroups (state, options = {}) {
      return new Promise((resolve, reject) => {
        ManagementGroup.getManagementsGroups(options)
          .then(({ data }) => {
            state.commit('setManagementsGroup', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getManagementGroup (state, id) {
      return new Promise((resolve, reject) => {
        ManagementGroup.getManagementGroup(id)
          .then(({ data }) => {
            state.commit('setManagementGroup', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createManagementGroup (state, params) {
      return new Promise((resolve, reject) => {
        ManagementGroup.createManagementGroup({ ...params })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateManagementGroup (state, { id, data }) {
      return new Promise((resolve, reject) => {
        ManagementGroup.updateManagementGroup(id, data)
          .then(({ data }) => {
            state.commit('setManagementGroup', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteManagementGroup (state, id) {
      return new Promise((resolve, reject) => {
        ManagementGroup.deleteManagementGroup(id)
          .then((response) => {
            resolve(response);
          })
          .catch(error => reject(error));
      });
    },
  },
};
